import { useCallback, useEffect } from "react";
import { useBlocker } from "react-router-dom";

const usePreventNavigationDuringLoading = (
  loading: boolean,
  options?: {
    confirmMessage?: string;
    onReloadAttempt?: () => void;
  }
) => {
  const shouldBlock = useCallback(() => {
    if (!loading) return false;
    return !window.confirm(
      options?.confirmMessage ||
        "Login is still in progress. Are you sure you want to leave now? "
    );
  }, [loading, options?.confirmMessage]);

  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (loading) {
        options?.onReloadAttempt?.();
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [loading, options?.onReloadAttempt]);

  return blocker; // For custom UI (optional)
};

export default usePreventNavigationDuringLoading;
